module.exports = __webpack_public_path__ + "img/paas_wrapbg3.6e3b544f.png";